<!--这是单独打开的svg界面,指定图的-->
<template>
  <div class="svgListBody" element-loading-text="拼命加载中">
    <div class="con">
      <div :class="['mysvg-tree', { 'active-tree': isTreeShow }]">
        <svgTree
          ref="svgTree"
          @checkItem="nowSvg = $event"
          slot="tree"
        ></svgTree>
      </div>
      <div
        :class="['elescoping', { 'active-img': isTreeShow }]"
        @click="isTreeShow = !isTreeShow"
      >
        <img src="@/assets/unifyImg/contract.png" v-show="!isTreeShow" />
        <img src="@/assets/unifyImg/expand2.png" v-show="isTreeShow" />
      </div>
      <webSvgPlayer
        :svgpath="realPath"
        ref="webSvgPlayer"
        :class="['webSvgPlayer', { 'webSvgPlayer-active': isTreeShow }]"
        slot="body"
      ></webSvgPlayer>
    </div>
    <svgDialog ref="svgDialog" @isLoad="loading = $event"></svgDialog>
    <!--调光按钮-->
    <dimmingDialog ref="dimmingDialog"></dimmingDialog>
    <!--窗帘高度设置-->
    <curtainDialog ref="curtainDialog"></curtainDialog>
  </div>
</template>
<script>
import treeBody from "@/components/module/slotModule/treeBody.vue";
import svgTree from "@/components/module/tree/svgTree.vue";
import webSvgPlayer from "@/components/module/svg/webSvgPlayer.vue";
import svgDialog from "@/components/module/svg/svgDialog.vue";
import dimmingDialog from "@/components/module/svg/dimmingDialog.vue";
import curtainDialog from "@/components/module/svg/curtainDialog.vue";
export default {
  components: {
    webSvgPlayer,
    svgTree,
    treeBody,
    svgDialog,
    dimmingDialog,
    curtainDialog,
    getToPageSvg: undefined,
    getRowList: {},
  },
  props: [],
  data() {
    return {
      nowSvg: {},
      loading: false,
      isTreeShow: true,
    };
  },
  mounted() {
    this.getToPageSvg = this.$route.params.svgName;
    // this.getToPageSvg = "高压配电系统图"
    debugPage = this;
  },

  computed: {
    getSvgTree() {
      return this.$store.svgStore.getters.getSvgTree;
    },
    realPath() {
      if (this.getToPageSvg == undefined) {
        if (this.nowSvg.fileName == undefined) {
          return "";
        }
        return "/static/svgFile/" + this.nowSvg.fileName;
        // return "/static/svgFile/" + "112.svg";
        //  return "/static/svgFile/" + '高压配电系统图.wdr.115.svg'
        // return "/static/svgFile/" + '111.wdr.17.svg'
      } else {
        this.digui_fn();
        return "/static/svgFile/" + this.getRowList.fileName;
      }
    },
  },
  watch: {},
  methods: {
    showSvgDialog(path) {
      this.$refs.svgDialog.showSvgDialog(path);
    },
    digui_fn() {
      var dataList = [this.getSvgTree];
      var myfullName = this.$route.params.svgName;
      var myfullList = {};
      var recursiveFunction = function() {
        const getStr = function(list) {
          list.forEach(function(row) {
            if (row.next && row.next.length != 0) {
              if (row.name == myfullName) {
                myfullList = row;
              }
              getStr(row.next);
            } else {
              if (row.name == myfullName) {
                myfullList = row;
              }
            }
          });
        };
        getStr(dataList);
      };
      recursiveFunction();
      this.getRowList = myfullList;
    },
  },
};
</script>

<style scoped>
.webSvgPlayer {
  width: 100%;
  height: 100%;
  margin-left: 3rem;
  transition: 0.3s;
}

.webSvgPlayer-active {
  margin-left: 0px;
}

.svgListBody {
  
  width: 100%;
  display: flex !important;
  /* align-items: center; */
  justify-content: space-between;
  padding: 0 !important;
}

.con {
  width: 100%;
  display: flex;
  position: relative;
  overflow: hidden;
}

.mysvg-tree {
  width: 3rem;
  height: 100%;
  flex-shrink: 0;
  overflow: hidden;
  background-color: #fff;
  padding: 12px;
  padding-top: 20px;
  box-sizing: border-box;
  transition: 0.3s;
  position: absolute;
  top: 0;
  left: 0px;
}

.active-tree {
  left: -3rem;
}

.elescoping {
  position: absolute;
  top: 20px;
  left: 3rem;
  z-index: 10;
  transition: 0.3s;
}

.active-img {
  left: 0px;
}
</style>
